<router-outlet />
<app-cookie-dialogue
  id="cookie-dialogue"
  role="dialog"
  aria-modal="false"
  aria-labelledby="cookie-dialogue-heading"
  [attr.lang]="displayUserLang"
/>
<cv-auth-overlay />
